module.exports = __webpack_public_path__ + "img/icon_text_a_trou.1effb474.svg";